import { viewJobNativeModule } from './ViewJobNativeModule';
import { callPromiseAssert } from '../../shared/util/callPromiseAssert';

export function navigateView<T>(
    sourceUrl: string,
    targetUrl: string,
    shareUrl: string,
    shareMessage: string | undefined,
): Promise<T> {
    return callPromiseAssert(
        viewJobNativeModule()?.navigateView<T>,
        'navigateView',
        sourceUrl,
        targetUrl,
        shareUrl,
        shareMessage,
    );
}
